
export default function isNotPassLengthChk(value, minLength, maxLength) {
    if(minLength === null){
        return value.length > maxLength;
    }else if(maxLength === null){
        return value.length < minLength;
    }
    return value.length < minLength || value.length > maxLength;
}
